"use client";

import { pushGtmEvent } from "@/utils/google-tag-manager";
import { GtmEvents, GtmProperties } from "@/constants/google-tag-manager";

export const StoreLinkButton = ({
	children,
	link,
	isMobile,
	pageTitle,
	name,
}) => {
	return (
		<div
			className="cursor-pointer flex px-8 h-14 items-center justify-center w-full first-of-type:border-r border-zinc-200"
			onClick={() => {
				pushGtmEvent(GtmEvents.CLICK_INSTALL, {
					[GtmProperties.GfeTopTen.PAGE_NAME]: pageTitle,
					[GtmProperties.GfeTopTen.POSITION]: "placeNumber",
					[GtmProperties.GfeTopTen.ELEMENT_TEXT]: name,
					[GtmProperties.GfeTopTen.DEVICE]: isMobile ? "mobile" : "desktop",
				});
				window.open(link, "_blank");
			}}>
			{children}
		</div>
	);
};
